import React from "react";
import Section from "./Section";
import Reveal from "./Reveal";
import { profile, education } from "../data";

function About() {
  return (
    <Section id="about" title="About" accent="Me">
      <div className="about-grid">
        <Reveal dir="left" className="card">
          <p>{profile.summary}</p>
          {profile.about.map((p) => <p key={p}>{p}</p>)}
          <p className="muted">📍 {profile.location}</p>
        </Reveal>
        <Reveal dir="right" className="card">
          <h3>Education</h3>
          <p><strong>{education.degree}</strong><br />{education.school}</p>
          <h3>Additional</h3>
          <ul className="bullets">
            {education.extra.map((e) => <li key={e}>{e}</li>)}
          </ul>
        </Reveal>
      </div>
    </Section>
  );
}

export default About;
